module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gOZU2"))).then(() => parcelRequire('d0iPb'));